const $inject = [];

const lbaHelpIconCtrl = function () {
  const vm = this;
  
  vm.showModal = false;
  vm.closeModal = closeModal;
  
  function closeModal() {
    vm.showModal = false;
  }
};

lbaHelpIconCtrl.$inject = $inject;

export default lbaHelpIconCtrl; 


// WEBPACK FOOTER //
// ./src/components/lbaHelpIcon/lbaHelpIconCtrl.js